import React from "react";
import { ILoginRequestDto, LoginRequestDto, AccountData } from "../../generated";
import { withRouter, RouteComponentProps } from "react-router-dom";
import * as Yup from 'yup';
import LoginActions from "../LoginActions"
import { canRequireUser } from "../loginHelpers"
import { Forms } from "../../common/components/CmForms";
import { navigateOrPush } from "../../common/navigateOrPush";
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import { InputError } from "../../common/components/inputError";
import { getParameterByName } from "./resetPassword";
import { CaldaieManagerIcon } from "../../common/components/icons";
const { Form, FormText, FormCheck, Submit } = Forms<ILoginRequestDto>()

interface Props extends RouteComponentProps {
    user: AccountData | null;
}

const validationSchema = Yup.object<Partial<ILoginRequestDto>>({
    user: Yup.string()
        .email('Email non valida')
        .required('Campo obbligatorio'),
    password: Yup.string()
        .required('Campo obbligatorio')
})


const LoginPage: React.FC<Props> = ({ user, history }) => {
    const [error, setError] = React.useState("")

    const onLogin = async (values: ILoginRequestDto) => {
        const request = new LoginRequestDto(values);
        try {
            await LoginActions.login(request)
            var returnUrl = getParameterByName(window.location, "returnUrl");
            if (returnUrl && returnUrl !== "") {
                navigateOrPush(history, returnUrl);
            }
            else {
                history.push("/");
            }
            return;
            history.push("/");
        }
        catch (e) {
            setError("Login fallito!");
        }
    }


    return (
        <div className="d-flex justify-content-center align-items-center">
            <div className="card card-outline-info shadow-lg mt-4" style={{ maxWidth: 800 }}>
                <div className="card-body">
                    <Form
                        onSubmit={onLogin}
                        initialValues={new LoginRequestDto()}
                        validationSchema={validationSchema}
                        floatingLabels
                        noPrompt
                    >
                        <>
                            <div className="row">
                                <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                                    <CaldaieManagerIcon width={100} color="#1e88e5" />
                                    <div style={{ fontSize: "2rem" }} className="text-theme mt-2">CALDAIE MANAGER</div>
                                </div>
                                <div className="col-12">
                                    <FormText
                                        name="user"
                                        label="Email"
                                        type="email"
                                    />
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <FormText
                                        name="password"
                                        label="Password"
                                        type="password"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <FormCheck
                                        name="rememberMe"
                                        label="Ricorda"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <InputError error={error} />
                                </div>
                                <div className="col-12 col-md-6 mb-2">
                                    <Submit additionalClass="w-100"><i className="fas fa-sign-in-alt"></i> ACCEDI</Submit>
                                </div>
                                <div className="col-12 col-md-6">
                                    <Link
                                        to={links.register}
                                        className="btn btn-outline-secondary w-100"
                                    >
                                        Registra la tua azienda
                                    </Link>
                                </div>
                                <div className="col-12 mt-3">
                                    <Link
                                        to={links.forgotPassword}
                                    >
                                        Hai dimenticato la password? clicca qui
                                    </Link>
                                </div>
                            </div>
                        </>
                    </Form>
                </div>
            </div>
        </div>
    );
}

export default withRouter(canRequireUser(LoginPage));